import {Injectable} from '@angular/core';
import {ApplicationFeatures} from '../../enums/enums';

@Injectable({providedIn: 'root'})
export class ConfigurationService {

  private walletApiUrl$ = '';

  private disabledFeaturesList$: ApplicationFeatures[] = [];

  constructor() {
  }

  get walletApiUrl() {
    return this.walletApiUrl$;
  }

  get disabledFeaturesList() {
    return this.disabledFeaturesList$ || [];
  }

  set walletApiUrl(url: string) {
    this.walletApiUrl$ = url;
  }

  set disabledFeaturesList(list: ApplicationFeatures[]) {
    this.disabledFeaturesList$ = list;
  }

  checkForDisabledFeature(featureToCheck: ApplicationFeatures): boolean {
    return this.disabledFeaturesList?.includes(featureToCheck);
  }

  checkForDisabledFeatures(featuresToCheck: ApplicationFeatures[]): boolean {
    return this.disabledFeaturesList
      ?.some(feature => featuresToCheck.find(featureToCheck => featureToCheck === feature));
  }

  checkIfAllFeaturesDisabled(featuresToCheck: ApplicationFeatures[]): boolean {
    return featuresToCheck
      ?.every(feature => this.disabledFeaturesList.find(disabledFeature => disabledFeature === feature));
  }
}
